export const paymentStatusOptions = [
    { label: 'Good Standing', value: 'GoodStanding' },
    { label: 'Past Due', value: 'PastDue' }
];
